import { render, staticRenderFns } from "./TicketKanbanBoard.vue?vue&type=template&id=05a19cde"
import script from "./TicketKanbanBoard.vue?vue&type=script&lang=js"
export * from "./TicketKanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./TicketKanbanBoard.vue?vue&type=style&index=0&id=05a19cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports